var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import EmptyComponent from 'components/EmptyComponent';
import DataTable from 'library/components/DataTable';
import { buttonColumn, chipColumn, monoColumn, nameColumn } from 'library/components/DataTable/cells';
import ListScreen, { ListAddButton, listPager } from 'library/components/ListScreen';
import { Document as DocumentResource } from 'constants/resources';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import DocumentDrawer from './DocumentDrawer';
var Documents = function (props) {
    var _a, _b, _c, _d;
    var t = props.translate;
    var navigate = useNavigate();
    var location = useLocation();
    var documentService = services.documentService, permissionService = services.permissionService;
    var _e = useState(1), pageNumber = _e[0], setPageNumber = _e[1];
    var _f = useState(''), searchValue = _f[0], setSearchValue = _f[1];
    var _g = useState(function () { var _a; return Boolean((_a = location.state) === null || _a === void 0 ? void 0 : _a.openNewDocument); }), drawerOpen = _g[0], setDrawerOpen = _g[1];
    var debounceRef = useRef(undefined);
    var canAdd = permissionService.hasPermissionToAdd(DocumentResource);
    var canShow = permissionService.hasPermissionToShow(DocumentResource);
    var filters = useMemo(function () {
        var name = searchValue.trim();
        return name ? { name: name } : {};
    }, [searchValue]);
    var _h = documentService.useDocuments(pageNumber, filters), data = _h.data, isLoading = _h.isLoading;
    var documents = (data === null || data === void 0 ? void 0 : data.documents) || [];
    var total = Number(((_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.count) || 0);
    var from = Number(((_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.from) || 0);
    var to = Number(((_c = data === null || data === void 0 ? void 0 : data.meta) === null || _c === void 0 ? void 0 : _c.to) || 0);
    var pages = Math.max(1, Number(((_d = data === null || data === void 0 ? void 0 : data.meta) === null || _d === void 0 ? void 0 : _d.pages) || 1));
    useEffect(function () {
        var state = location.state;
        if (!(state === null || state === void 0 ? void 0 : state.openNewDocument))
            return;
        setDrawerOpen(true);
        navigate('/documents', { replace: true, state: null });
    }, [location.state, navigate]);
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () {
            setPageNumber(1);
            setSearchValue(value);
        }, 300);
    };
    var columns = useMemo(function () { return __spreadArray([
        monoColumn({ key: 'id', title: t('id'), width: '88px', value: function (document) { return document.getId(); } }),
        nameColumn({ key: 'name', title: t('name'), width: 'minmax(220px, 1.6fr)', value: function (document) { return document.getName(); } }),
        chipColumn({
            key: 'lines',
            title: t('documentLinesCount'),
            width: '180px',
            tone: 'is-sky',
            dot: true,
            value: function (document) { return t('linesCount', { count: document.getDocumentLinesCount() }); }
        })
    ], (canShow ? [buttonColumn({
            title: t('action'),
            width: '120px',
            accent: true,
            label: t('common:buttons.show'),
            onClick: function (document) { return navigate("/documents/".concat(document.getId())); }
        })] : []), true); }, [t, canShow, navigate]);
    return (_jsxs(ListScreen, { title: t('header.documents'), count: t('countBadge', { count: total }), subtitle: t('subtitle'), actions: canAdd ? (_jsx(ListAddButton, { onboarding: true, label: t('common:buttons.newDocument'), onClick: function () { return setDrawerOpen(true); } })) : undefined, search: { placeholder: t('searchPlaceholder'), onChange: onSearchValueChange }, children: [_jsx(DataTable, { compact: true, minWidth: "640px", loading: isLoading, rows: documents, rowKey: function (document) { return document.getId(); }, empty: _jsx(EmptyComponent, { description: t('empty') }), columns: columns, pager: listPager({
                    total: total,
                    page: pageNumber,
                    pages: pages,
                    meta: t('showingRange', { from: from, to: to, total: total }),
                    previous: t('previous'),
                    next: t('next'),
                    center: t('pageOf', { page: pageNumber, pages: pages }),
                    setPage: setPageNumber
                }) }), _jsx(DocumentDrawer, { visiable: drawerOpen, onCloseDrawer: function () { return setDrawerOpen(false); } })] }));
};
export default localeTranslator(Documents, 'documents');
